/**
 * Module reducer.
 */
const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'merge': {
      return {
        ...state,
        ...payload,
      };
    }
    default:
      break;
  }

  return null;
};

export default reducer;
